import { render, staticRenderFns } from "./studySchedule.vue?vue&type=template&id=b1872e9e&scoped=true"
import script from "./studySchedule.vue?vue&type=script&lang=js"
export * from "./studySchedule.vue?vue&type=script&lang=js"
import style0 from "./studySchedule.vue?vue&type=style&index=0&id=b1872e9e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1872e9e",
  null
  
)

export default component.exports